/** YouTube video IDs are 11 characters from this set. */
const YOUTUBE_ID_RE = /^[a-zA-Z0-9_-]{11}$/;

/**
 * Normalize a pasted YouTube URL to a canonical embed `src` for iframes.
 * Supports watch, Shorts, youtu.be, and existing /embed/ links.
 * @param {string | null | undefined} url
 * @returns {string} `https://www.youtube.com/embed/<id>` or "" if not parseable
 */
export function youtubeUrlToEmbedSrc(url) {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";

  let id = null;
  try {
    const href = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
    const u = new URL(href);
    const host = u.hostname.replace(/^www\./i, "").toLowerCase();

    if (host === "youtu.be") {
      id = u.pathname.split("/").filter(Boolean)[0] ?? null;
    } else if (host.endsWith("youtube.com")) {
      const path = u.pathname;
      if (path.startsWith("/embed/")) {
        id = path.slice("/embed/".length).split("/")[0] || null;
      } else if (path.startsWith("/shorts/")) {
        id = path.slice("/shorts/".length).split("/")[0] || null;
      } else if (path === "/watch" || path.startsWith("/watch")) {
        id = u.searchParams.get("v");
      }
    }
  } catch {
    return "";
  }

  if (!id) return "";
  const clean = id.split(/[?&#]/)[0];
  if (!YOUTUBE_ID_RE.test(clean)) return "";
  return `https://www.youtube.com/embed/${clean}`;
}
